import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("aside", { id: "attach-area" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_global_error = _resolveComponent("the-global-error")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_partial_skip_navigation_link = _resolveComponent("partial-skip-navigation-link")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    class: _normalizeClass(["pa-0 ma-0 evo-app main-background", {
      'evo-app--hide-scrollbar': !_ctx.showScrollbar,
      'evo-app--mobile': _ctx.isMobile,
      'evo-app--smallest': _ctx.isExtraSmall,
      'evo-app--file-dragging': _ctx.fileDragActive,
      ..._ctx.classes,
    }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_global_error),
      _createVNode(_component_router_view),
      _createElementVNode("footer", null, [
        _createVNode(_component_partial_skip_navigation_link, {
          style: {"bottom":"160px","right":"40px","top":"unset","left":"unset"},
          targetId: "to-main"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("aria.common.skipToTopLink")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("input", {
          type: "file",
          tabindex: "-1",
          class: "visually-hidden",
          "aria-hidden": "true",
          id: "file-upload-input",
          "aria-label": _ctx.$t('aria.common.uploadFile')
        }, null, 8, _hoisted_1)
      ]),
      _hoisted_2
    ]),
    _: 1
  }, 8, ["class"]))
}